// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__F1duW","location":"Header_location__btiJx"};